// extracted by mini-css-extract-plugin
export default {"close":"close__UcGau","disabled":"disabled__MUBlQ"};